import React, { useState, useEffect } from 'react';
import { MdClose } from 'react-icons/md';
import useScrollLock from '../../../hooks/useScrollLock';

interface EditTaskModalProps {
    open: boolean;
    initialText: string;
    onClose: () => void;
    onSave: (newText: string) => void;
}

const EditTaskModal: React.FC<EditTaskModalProps> = ({ open, initialText, onClose, onSave }) => {
    const [taskText, setTaskText] = useState(initialText);

    useScrollLock(open);

    useEffect(() => {
        setTaskText(initialText);
    }, [initialText]);

    const handleSave = () => {
        if (taskText.trim()) {
            onSave(taskText.trim());
            onClose();
        }
    };

    if (!open) return null;

    return (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-[60] p-4">
            <div className="bg-[#FFF8F0] rounded-2xl p-6 sm:p-8 max-w-lg w-full border border-gray-200/60 shadow-xl">
                <div className="flex justify-between items-center mb-6">
                    <h3 className="text-2xl font-medium text-gray-900">Edit Task</h3>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-600 text-2xl transition-colors"
                    >
                        <MdClose />
                    </button>
                </div>

                <div className="space-y-6">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Task Description
                        </label>
                        <input
                            type="text"
                            value={taskText}
                            onChange={(e) => setTaskText(e.target.value)}
                            placeholder="What do you need to do?"
                            className="w-full px-4 py-3 bg-white border border-gray-200/60 rounded-xl text-gray-900 placeholder:text-gray-400 focus:ring-1 focus:ring-orange-400/30 focus:border-orange-300/50 focus:outline-none transition-all duration-300 text-base"
                            autoFocus
                            onKeyPress={(e) => e.key === 'Enter' && handleSave()}
                        />
                    </div>

                    <div className="flex gap-3 pt-2">
                        <button
                            onClick={onClose}
                            className="flex-1 px-4 py-3 bg-white border border-gray-200 hover:border-gray-300 text-gray-700 rounded-xl font-medium transition-all duration-300 text-sm"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={handleSave}
                            disabled={!taskText.trim() || taskText.trim() === initialText}
                            className={`flex-1 px-4 py-3 rounded-xl font-medium transition-all duration-300 text-sm ${!taskText.trim() || taskText.trim() === initialText
                                    ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                                    : 'bg-orange-600 hover:bg-orange-700 text-white'
                                }`}
                        >
                            Save Changes
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditTaskModal;
